import { render, staticRenderFns } from "./LegalEntitySponsor.vue?vue&type=template&id=354f4d62&"
import script from "./LegalEntitySponsor.vue?vue&type=script&lang=js&"
export * from "./LegalEntitySponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354f4d62')) {
      api.createRecord('354f4d62', component.options)
    } else {
      api.reload('354f4d62', component.options)
    }
    module.hot.accept("./LegalEntitySponsor.vue?vue&type=template&id=354f4d62&", function () {
      api.rerender('354f4d62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/LegalEntitySponsor.vue"
export default component.exports